// removed by extract-text-webpack-plugin
module.exports = {"linkContainer":"src-components-events----EventListItem-module---linkContainer---3ywYC","eventListItem":"src-components-events----EventListItem-module---eventListItem---QjvTf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/events/EventListItem.module.css
// module id = 182
// module chunks = 35783957827783 36829835628245 276599015875551